import type {Identified} from 'typings/portaro.be.types';
import {GenericReactivePageableList} from './reactive-pageable-list';
import type { PageableListSettings} from './reactive-pageable-list';


export type SortOrder = {isAscending: boolean};

const INITIAL_SORTING = {isAscending: true};

export class SortablePageableList<ITEM extends Identified<ID>, ID> extends GenericReactivePageableList<ITEM, ID, SortOrder> {

    constructor({loadListItems, loadListSize, initialParams, pageSize, loadSingleItemFunction}: Omit<PageableListSettings<ITEM, ID, SortOrder>, 'initialParams'> & Partial<Pick<PageableListSettings<ITEM, ID, SortOrder>, 'initialParams'>>) {
        super({loadListItems, loadListSize, initialParams: initialParams ?? INITIAL_SORTING, pageSize, loadSingleItemFunction});
    }

    public isSortedInAscendingOrder(): boolean {
        return this.params.isAscending;
    }

    public setAscendingSortingOrder(ascending: boolean) {
        if (this.currentParams.isAscending !== ascending) {
            this.currentParams.isAscending = ascending;
            this.emitCurrentData();
        }
    }

    public sort(comparator: (x: ITEM, y: ITEM) => number) {
        this.items = this.items.toSorted(comparator);
        this.emitCurrentData();
    }
}